import React, { useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import './ColorPaletteSelect.css';
import { COLOR_PALETTE, COLOR_PALETTE_COLUMNS, COLOR_PALETTE_SECTIONS, findColorPaletteIndex, normalizeColorHex } from '../utils/ColorPalette';

export type ColorPaletteSelectProps = {
  color: string;
  onChange: (colorHex: string) => void;
  className?: string;
};

function otherButtonLabel(isOpen: boolean): string {
  if (isOpen) {
    return 'その他の色を閉じる';
  }
  return 'その他の色…';
}

function rootClassName(extraClassName: string | undefined): string {
  const classNames = ['ColorPaletteSelect'];
  if (extraClassName) {
    classNames.push(extraClassName);
  }
  return classNames.join(' ');
}

function swatchClassName(isSelected: boolean): string {
  const classNames = ['ColorPaletteSelect-swatch'];
  if (isSelected) {
    classNames.push('ColorPaletteSelect-swatch_selected');
  }
  return classNames.join(' ');
}

function displayColorOf(color: string): string {
  const normalized = normalizeColorHex(color);
  if (normalized !== '') {
    return normalized;
  }
  return color;
}

export function ColorPaletteSelect(props: ColorPaletteSelectProps): JSX.Element {
  const [isOtherOpen, setIsOtherOpen] = useState(false);
  const selectedIndex = findColorPaletteIndex(props.color);
  const displayColor = displayColorOf(props.color);

  function handleOtherColorChange(result: ColorResult): void {
    const normalized = normalizeColorHex(result.hex);
    if (normalized !== '') {
      props.onChange(normalized);
    }
  }

  return (
    <div className={rootClassName(props.className)}>
      <div className="ColorPaletteSelect-current">
        <div className="ColorPaletteSelect-current_bar" style={{ backgroundColor: displayColor }} />
        <span className="ColorPaletteSelect-current_text">{displayColor}</span>
      </div>
      {COLOR_PALETTE_SECTIONS.map((section) => (
        <div className="ColorPaletteSelect-grid" key={section.key} style={{ gridTemplateColumns: 'repeat(' + COLOR_PALETTE_COLUMNS + ', 32px)' }}>
          {COLOR_PALETTE.slice(section.start, section.start + section.count).map((hex, offset) => {
            const index = section.start + offset;
            return (
              <button
                type="button"
                key={hex}
                className={swatchClassName(index === selectedIndex)}
                style={{ backgroundColor: hex }}
                title={hex}
                aria-label={hex}
                aria-pressed={index === selectedIndex}
                onClick={() => props.onChange(hex)}
              />
            );
          })}
        </div>
      ))}
      <button
        type="button"
        className="ColorPaletteSelect-other_button"
        aria-expanded={isOtherOpen}
        onClick={() => setIsOtherOpen((isOpen) => !isOpen)}
      >
        {otherButtonLabel(isOtherOpen)}
      </button>
      {isOtherOpen && (
        <div className="ColorPaletteSelect-other">
          <SketchPicker
            color={props.color}
            presetColors={[]}
            disableAlpha={true}
            onChange={handleOtherColorChange}
          />
        </div>
      )}
    </div>
  );
}
